import React from 'react';
import { styled } from 'styled-components';
const PDF = (props) => {
    return (React.createElement(PDFStyled, { type: "application/pdf", style: props.style, data: props.link }));
};
export default PDF;
const PDFStyled = styled.object `
  width: 100%;
`;
//# sourceMappingURL=PDF.js.map